<template>
  <div class="page" v-wechat-title="$route.meta.title='攻略推荐'">
    <!--搜索-->
    <div class="station-search border-box box">
      <div class="station-search-con box">
        <form class="station-search-bar border-box flex" action="." v-on:submit.prevent="search" @click.stop="getFocus">
          <img class="station-search-icon" src="../../assets/icon-search.png" alt="" @click.stop='search'>
          <input type="search" class="station-search-input" placeholder="搜索攻略关键词" value="" v-model='inputValue'/>
          <img class="station-input-close none" src="../../assets/input-close.png" alt="" v-show="inputValue"
               @click.stop="inputValue=''">
        </form>
        <div class="search-history-cancel flex" v-if="searchShow==1" @click="searchShow=0">取消</div>
      </div>
    </div>

    <div class="list clearfix">
      <div class="fl list-item border-box" v-for="(item,index) in root" :key="index" @click="toStation(item.type,item.id)">
        <div class="item-type hide">{{item.label}}</div>
        <div class="item-info hide2">{{item.name}}</div>
        <img class="img" v-lazy="item.headimg" alt="">
      </div>
    </div>

    <p class="load-tip">{{loadText}}</p>

    <!--搜索弹窗-->
    <div class="search-page" v-show="searchShow==1">
      <div class="search-box">
        <form class="search-form border-box" v-on:submit.prevent="search">
          <span @click.stop="searchShow=0"><img src="../../assets/icon_28.png" alt=""></span>
          <input type="search" placeholder="搜索内容" v-model='inputValue'  ref="searchInp"  id="searchInp" />
          <div @click.stop='search' v-if="searchList.length<=0||inputValue==''">搜索</div>
          <div style="color:#ff5767;" @click.stop="searchList=[],inputValue=''" v-else>取消</div>
        </form>
      </div>
      <div class="search-scoll" id="scollBox">
        <div class="search-list">
          <div class="search-li" :class="item.type=='spot'?'search-li1':''" v-for="(item,index) in searchList" :key="index" @click="selectSearch(index)">
            <div v-html="initTxt(item.name)"></div>
            <p v-if="item.type=='spot'"><font v-html="initTxt(item.name)"></font></p>
          </div>
        </div>
        <p v-show="searchList.length>0" class="load-tip load-tip1" id="loadTip" style="height: auto;">{{loadText1}}</p>
      </div>
    </div>
    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>
<script>
  import {uploadUserBrowse,citySiteRoot} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo} from '@/utils/wechat'
  import {setStore, getStore, removeStore,loadMore ,scollLoadMore} from '@/config/mUtils'
  import P400 from '../../components/P400'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        inputValue: '',//搜索关键词
        loadEnd: false, //数据加载结束则赋值为true
        code:'',
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        searchList:[],//搜索列表
        searchShow: 0, //是否显示搜索窗
        searchFocus:false,
        searchTip:0,
        page: 1,
        rows:10,
        pageAlert:1,//弹窗内分页 page
        rowsAlert:15,//弹窗内分页 rows
        root: [], //列表
        total:'',//列表总条数
        loadText: "加载更多",
        loadText1: '', //弹窗列表提示
        history: [], //历史记录
        P400: 0, //系统维护中
      }
    },
    computed: {},

    beforeRouteLeave (to, from, next) {
      if(to.path.indexOf('waterfall') > -1){
        to.meta.keepAlive = false;
      }
      next();
    },
    created(){
      let self = this;
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.code = this.$route.query.code;
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey);
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
      } else {
        setStore("appKey", {"appKey": ""});
      }

      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = { citycode: "1", city: "全国", address: "" };
          setStore("cityInfo",self.cityInfo);
          self.initData(self.page);
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData(self.page);
        });
      }
      let history = getStore("history", 1) || "";
      if (history) {
        this.history = history.history
      }
      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
      document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
    },
    methods: {
      //初始化：获取景区数据
      async initData(page){
        let res = await citySiteRoot({
          TimeStamp: this.TimeStamp,
          key:this.inputValue,
          code:this.code,
          page: page,
          rows: this.rows
        });
        if(res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.data
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          var share = res.data.share;
          let link = '/city-strategy-list?code=' + this.code + '&key=' + this.inputValue + '&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey;
          if(share == null){
            let title = '攻略推荐';
            let desc = '讲人文 . 听趣史 . 说美食 . 游景区';
            let img = '';
            wxShareme(title, desc, img, link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

        }else {
          this.$loading.hide();
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //获取搜索内容信息
      async initSearchData(page){
        let res = await citySiteRoot({
          TimeStamp: this.TimeStamp,
          key:this.inputValue,
          code:this.code,
          page: page,
          rows: this.rowsAlert,
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          this.searchTip = 1;
          this.searchTotal = res.data.total;
          let searchList = res.data.data;
          console.log(page,this.searchTotal,this.rowsAlert,page >= Math.ceil(this.searchTotal / this.rowsAlert));
          if (page >= Math.ceil(this.searchTotal / this.rowsAlert)) {
            this.loadText1 = '已经到底了'
          } else {
            this.loadText1 = '加载更多'
          }
          if (searchList.length > 0) {
            this.searchList = [...this.searchList, ...searchList];
          } else {
            if (page == 1) {
              this.searchList = [];
              this.$toast('暂无搜索结果');
            } else {
              this.loadText1 = '已经到底了'
            }
          }
        }else {
          this.$toast(res.errmsg)
        }

      },


      //上传浏览数据
      async sendUserBrowse(){
        let res = await uploadUserBrowse({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //发送搜索信息inputVaule
      search(){
        this.inputValue = this.inputValue.replace(/(^\s*)|(\s*$)/g, "");
        if(this.inputValue == ''){
          this.$toast('请输入搜索关键词');
          return;
        }
        this.$loading.show('数据加载中');
        this.pageAlert = 1;
        this.searchList = [];
        this.initSearchData(this.pageAlert)
      },

      //选择搜索结果
      selectSearch: function(index){
        this.toStation(this.searchList[index].type,this.searchList[index].id)
        this.searchShow = 0;
      },

      //标注搜索结果
      initTxt: function (txt){
        return txt.replace(this.inputValue, '<span style="color: #ff8a00">'+ this.inputValue + '</span>')
      },


      getFocus(){
        this.searchShow=1;
        this.searchList=[];
        this.$nextTick( () =>{
          this.$refs.searchInp.focus()
        })
      },

      toStation(type,id){
        if(type==0){
          this.$router.push({
            path: `/station?${'specialId='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }else{
          this.$router.push({
            path: `/city-strategy-detail?${'id='+id+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },

      handleFun(){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      handleFun1: function (){
        let self = this;
        self.$nextTick(function() {
          scollLoadMore(self,'scollBox','loadTip',function(){
            self.pageAlert += 1;
            self.initSearchData(self.pageAlert);
          });
        })
      },
    },
    components: {P400},
    //格式化数据
    filters: {
      initNumber: function (num) {
        if (num > 10000) {
          num = (num / 10000).toFixed(2) + '万'
        } else if (num > 1000) {
          num = (num / 1000).toFixed(2) + '千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  .page{padding:1.2rem .26rem;background-color:#fff}

  /*搜索*/
  .station-search{position:fixed;top:0;left:0;z-index:9;padding:.2rem .24rem;width:100%;height:1.08rem;background:#fff}
  .station-search-con{position:relative;z-index:99}
  .station-search-bar{display:block;margin-top:0;height:.68rem;border-radius:.06rem;line-height:.68rem}
  .station-search-input{width:80%;height:.68rem;line-height:.68rem}
  .station-search-icon{position:absolute;top:50%;right:0;z-index:999;padding:.2rem .2rem .2rem 0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}
  .station-input-close{position:absolute;top:50%;right:.5rem;z-index:999;padding:.2rem;width:.19rem;height:.19rem;-webkit-transform:translateY(-50%);transform:translateY(-50%)}

  /*列表*/
  .list-item{position:relative;padding:0 .24rem;width: 48.4%;height: 4.42rem;margin-top:.22rem;border-radius: .08rem;overflow: hidden;}
  .list-item:after{content: '';position: absolute;left: 0;top:0;width: 100%;height: 100%;border-radius: .08rem;background: rgba(0,0,0,.35);}
  .item-type{position: relative;z-index:1;margin-top:.18rem;font: bold .34rem "Microsoft YaHei";font-style:italic;color: #fff;}
  .item-info{position: relative;z-index:1;margin-top:.2rem;font:  .24rem/.34rem "Microsoft YaHei";color: #fff;}
  .list-item img{position:absolute;top:0;left:0;width: 100%;height: 100%;object-fit: cover;border-radius: .08rem;}
  .list-item:nth-of-type(1){margin-right: 3.2%;margin-top: 0;}
  .list-item:nth-of-type(2){height: 2.1rem;margin-top:0;margin-bottom: .22rem;margin-right: 0!important;}
  .list-item:nth-of-type(3){height: 2.1rem;margin-top:0;}
  .list-item:nth-of-type(2n){margin-right: 3.2%;}

  /*搜索页面*/
  .search-page{ position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 10; background-color: #edefed;}
  .search-box{ padding-top: .12rem; padding-bottom: .19rem; }
  .search-form{ position: relative; display: block; padding: .16rem 1.2rem .16rem .72rem; height: 1rem; background-color: #fff; }
  .search-form span{ position: absolute; left: 0; top: .16rem; width: .72rem; height: .68rem; }
  .search-form span img{ width: .16rem; height: .29rem; margin: .2rem 0 0 .3rem }
  .search-form div{ position: absolute; right: 0; top: .16rem; width: 1.2rem; height: .68rem; line-height: .68rem; font-size: .3rem; color: #333; text-align: center; }
  .search-form input{ display: block; padding: .09rem .25rem; width: 100%; height: .68rem; line-height: .68rem; font-size: .26rem; color: #333; background-color: #f5f5f5; border-radius: .12rem; overflow: hidden; }
  .search-scoll{ width: 100%; position: absolute;top: 1.31rem;bottom: 0;left: 0;width: 100%;overflow-y: scroll; background-color: #fff; }
  .search-list{padding: 0 .32rem 0 .26rem; }
  .search-li{ position: relative;}
  .search-li img{ position: absolute; left: 0; top: .3rem; width: .28rem; height: .34rem; }
  .search-li div{ padding: .3rem 0 .26rem; width: 100%; height: .34rem; line-height: .34rem; font-size: .26rem; color: #666; border-bottom: .01rem solid #e5e5e5; }
  .search-li1 div{ padding: .2rem 0 .08rem; border-bottom: 0; }
  .search-li1 img{ left: .01rem; top: .32rem; height: .28rem; }
  .search-li p{ padding-bottom: .2rem; line-height: .2rem; font-size: .18rem; color: #b2b2b2; border-bottom: .01rem solid #e5e5e5; }
  .search-li span{ font-weight: normal; color: #ff8a00; }
</style>



// WEBPACK FOOTER //
// src/page/city-site/city-strategy-list.vue